import { useEffect, useMemo, useState } from "react";
import "../styles/BannersComponent.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FeedbackFormComponent from "./FeedbackFormComponent";

export const Banners = ({ position }) => {
  const [banners, setBanners] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchBanners = async () => {
    try {
      const response = await fetch("https://lims.backend.demowts.ru/api/app/banners", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const responseData = await response.json();

      if (response.ok) {
        setBanners(responseData.data);
      }
    } catch (error) {
      console.error("Ошибка при получении данных баннеров:", error.message);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const onClick = (banner) => {
    if (banner.link === null || banner.link === "") {
      setIsModalOpen(true);
      return;
    }

    window.location.href = banner.link;
  };

  const closeModal = () => setIsModalOpen(false);

  const CustomPrevArrow = (props) => (
    <div {...props} style={{ top: "50%", left: "-50px", zIndex: 1, width: "40px", height: "100%", display: "grid", placeContent: "center" }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="34" viewBox="0 0 21 34" fill="none">
        <path d="M17.6667 3.66666L4.33333 17L17.6667 30.3333" stroke="black" strokeWidth="6" strokeLinecap="round" />
      </svg>
    </div>
  );

  const CustomNextArrow = (props) => (
    <div {...props} style={{ top: "50%", right: "-50px", zIndex: 1, width: "40px", height: "100%", display: "grid", placeContent: "center" }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="34" viewBox="0 0 21 34" fill="none">
        <path d="M3.33337 3.66666L16.6667 17L3.33337 30.3333" stroke="black" strokeWidth="6" strokeLinecap="round" />
      </svg>
    </div>
  );

  const settings = {
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    useCSS: true,
    cssEase: "linear",
    infinite: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    afterChange: (current) => setCurrentSlide(current),
  };

  const filteredBanners = useMemo(() => {
    return banners.filter((banner) => banner.position === position);
  }, [banners, position]);

  return (
    <div className={`banners_list_${position}`}>
      {filteredBanners.length > 1 ? (
        <Slider {...settings}>
          {filteredBanners.map((banner) => (
            <div key={banner.id} className="banners_item" onClick={() => onClick(banner)}>
              <img src={banner.imageUrl} alt={banner.link} />
            </div>
          ))}
        </Slider>
      ) : (
        <>
          {filteredBanners.map((banner) => (
            <div key={banner.id} className="banners_item" onClick={() => onClick(banner)}>
              <img src={banner.imageUrl} alt={banner.link} />
            </div>
          ))}
        </>
      )}

      {isModalOpen && <FeedbackFormComponent onClose={closeModal} />}
    </div>
  );
};
